<template>
  <v-menu
    offset-y
    :close-on-content-click="false"
  >
    <template #activator="{ on }">
      <span v-on="on">
        <BTooltipButton
          :icon="settings[0]"
          :tooltip="settings[1]"
          :disabled="disabled"
          icon-size="18px"
          small
          depressed
          dense
          top
        />
      </span>
    </template>

    <v-color-picker
      :value="color"
      :swatches="swatches"
      show-swatches
      mode="hexa"
      hide-mode-switch
      @update:color="onChange"
    />
  </v-menu>
</template>

<script>
import { SETTINGS } from './utils'
import BTooltipButton from '@/components/common/BTooltipButton.vue'


const SWATCHES = [
  ['#000000', '#acacac', '#cccccc', 'transparent'],
  ['#ff0000', '#aa0000', '#550000', '#FFFFFF'],
  ['#ffff00', '#aaaa00', '#555500'],
  ['#00ff00', '#00aa00', '#005500'],
  ['#0000ff', '#0000aa', '#000055'],
]

export default {
  name: 'BEditorActionsColor',
  components: {
    BTooltipButton,
  },
  inheritAttrs: false,
  props: {
    $key: {
      type: String,
      required: true,
      validator: (prop) => (
        ['color', 'color_bg'].includes(prop)
      ),
    },
    disabled: Boolean,
    getMarkAttrs: {
      type: Function,
      required: true,
    },
    commands: {
      type: Object,
      required: true,
    },
  },
  data: (vm) => ({
    settings: SETTINGS[vm.$key],
    swatches: SWATCHES,
    color: { hex: vm.getMarkAttrs(vm.$key).color },
  }),
  computed: {
    icon() {
      const index = this.activeIndex < 0 ? 0 : this.activeIndex
      return this.list[index].icon
    },
  },
  watch: {
    getMarkAttrs() {
      const { color } = this.getMarkAttrs(this.$key)
      if (this.color.hex !== color) this.color.hex = color
    },
  },
  methods: {
    onChange(settings) {
      const { hex, alpha } = settings
      const color = !alpha ? '' : hex
      if (hex === this.color) return
      this.commands[this.$key]({ color })
    },
  },
}
</script>
